import api from '@/api';
import { API_BASE_URL } from '../../index';
import {
  QuestDREAccrualReportRequest,
  QuestDREReportRequest,
} from './DRE.type';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportDRE(params: QuestDREReportRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/DRE`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function getQuestReportDREAccrual(
  params: QuestDREAccrualReportRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/DRE-accrual`,
    params,
  )) as unknown;

  return result as BlobPart;
}
